import React from "react";

const TeamsCard = ({ image, name }) => {
  return (
    <div className="flex flex-col items-center m-4 teams-card">
      <div className="w-32 h-32 rounded-full">
        <img src={image} alt="Imagen" className="w-full h-full object-cover" />
      </div>
      <p className="mt-2 text-center text-sm">{name}</p>
    </div>
  );
};

export default TeamsCard;
